import Vue from 'vue'
import VueRouter from 'vue-router'

import HomeIndex from '@/components/HomeIndex.vue'
import LoginPage from '@/components/LoginPage.vue'
import FeedbackInbox from '@/components/FeedbackInbox.vue'
import DepartmentManagement from '@/components/DepartmentManagement.vue'
import AppointmentSlotManagement from '@/components/AppointmentSlotManagement.vue'
import AppointmentInbox from '@/components/AppointmentInbox.vue'

import { ensureSession, state } from '@/store/session'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeIndex,
    meta: { title: '首页' }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    // 已登录时不再展示登录页
    meta: { title: '登录', guestOnly: true }
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: FeedbackInbox,
    meta: { title: '患者反馈', requiresAuth: true }
  },
  {
    path: '/feedback-admin',
    name: 'feedback-admin',
    redirect: { name: 'feedback' }
  },
  {
    path: '/departments',
    name: 'departments',
    component: DepartmentManagement,
    meta: { title: '科室维护', requiresAuth: true }
  },
  {
    path: '/appointment-slots',
    name: 'appointment-slots',
    component: AppointmentSlotManagement,
    meta: { title: '号源维护', requiresAuth: true }
  },
  {
    path: '/appointments',
    name: 'appointments',
    component: AppointmentInbox,
    meta: { title: '预约记录', requiresAuth: true }
  },
  {
    path: '/wechat-followers',
    name: 'wechat-followers',
    // 懒加载：这个页面用了 Element UI 的表格，按需加载后，患者端的建档/反馈页
    // 不会白白多下载一份 Element 的代码和样式
    component: () => import('@/components/WechatFollowers.vue'),
    meta: { title: '微信关注用户', requiresAuth: true }
  },
  {
    path: '/patient-revisit',
    name: 'patient-revisit',
    component: () => import('@/components/PatientRevisit.vue'),
    meta: { title: '患者回访', requiresAuth: true }
  },
  {
    // 患者手机端页面（建档 / 预约 / 反馈）已迁移到独立工程 qiming-h5-interhos，
    // 本项目只保留院内员工 PC 管理端。
    path: '*',
    redirect: { name: 'home' }
  }
]

const router = new VueRouter({
  // hash 模式不依赖服务端 rewrite，部署到任意静态目录都能直接访问和刷新
  mode: 'hash',
  routes
})

router.beforeEach(async (to, from, next) => {
  // 公开页（如患者建档页）不需要员工登录态：
  // 少发一次 /api/auth/me，患者在微信里点开就能直接看到表单，
  // 也避免微信里那点网络延迟让页面白屏等待。
  if (!to.meta.requiresAuth && !to.meta.guestOnly) {
    next()
    return
  }

  await ensureSession()
  // 读取实时状态，登录/退出后守卫能立刻看到最新结果
  const authenticated = Boolean(state.employee)

  if (to.meta.requiresAuth && !authenticated) {
    next({ name: 'login', query: { redirect: to.fullPath } })
    return
  }

  if (to.meta.guestOnly && authenticated) {
    next({ name: 'wechat-followers' })
    return
  }

  next()
})

router.afterEach((to) => {
  document.title = to.meta.title ? `${to.meta.title} · 启明服务管理平台` : '启明服务管理平台'
})

export default router
